import React, { PropsWithChildren } from 'react'

import InvalidESignatureLinkMessage from '@/components/misc/ReferralESignature/components/InvalidESignatureLinkMessage'
import LoadingWidget from '@/components/widgets/LoadingWidget'
import { useReferralWithESignatureDetailsQuery } from '@/hooks/useReferralWithESignatureDetailsQuery'

const ReferralWithESignatureDetailsProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const referralWithESignatureQuery = useReferralWithESignatureDetailsQuery()

  if (referralWithESignatureQuery.isLoading) {
    return <LoadingWidget />
  }

  const error = referralWithESignatureQuery.error
  const referral = referralWithESignatureQuery.data

  // An error most likely means the eSignature has already been signed so we
  // can show a friendly message to the user.
  if (error || !referral) {
    return <InvalidESignatureLinkMessage />
  }

  if (referral.dateConsented) {
    return <InvalidESignatureLinkMessage />
  }

  return children
}

export default ReferralWithESignatureDetailsProvider
